import { Flex, Text, TextProps } from '@radix-ui/themes';
import React, { ReactNode } from 'react';
import './form-field.css';
export const FormField = ({
    label,
    error,
    children,
    required,
    htmlFor,
    labelHighContrast = false,
    weight = 'regular'
}: {
    children: ReactNode;
    required?: boolean;
    label: string;
    error?: string | null;
    htmlFor?: string
    labelHighContrast?: boolean
    weight?: TextProps['weight']
}) => {
    return (
        <Flex className="form-field" direction="column">
            <label htmlFor={htmlFor}>
                <Text as="div" size="2" mb="1" weight={weight} color="gray" highContrast={labelHighContrast}>
                    {label}
                    {required && (
                        <Text as="span" color="red" aria-required>
                            *
                        </Text>
                    )}
                </Text>
            </label>
            {children}
            {error && (
                <Text color="red" size="2" weight="regular">
                    {error}
                </Text>
            )}
        </Flex>
    );
};
